import { motion } from "framer-motion";
import { useEffect } from "react";
// import heroVideo from "../assests/media-hero.mp4"; // 🎥 Background video for hero
// import movie1 from "../assests/movie1.jpg"; // Sample media image 1
// import movie2 from "../assests/movie2.jpg"; // Sample media image 2

export default function MediaEntertainment() {
   
  return (
    <div className="bg-gray-50 text-gray-900 font-orbitron">

      {/* Hero Section */}
      <section className="relative w-full h-[70vh] flex items-center justify-center text-center overflow-hidden">
        {/* <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={heroVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        <div className="absolute inset-0 bg-gradient-to-r from-purple-700/70 via-indigo-600/50 to-pink-600/70"></div>

        <motion.div
          initial={{ opacity: 0, y: -40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="relative z-10 px-6 max-w-3xl"
        >
          <h1 className="text-4xl md:text-6xl font-bold mb-4 text-white drop-shadow-lg">
            Media & Entertainment AI Solutions
          </h1>
          <p className="text-lg md:text-xl text-gray-100 leading-relaxed">
            Transform your creative projects with AI-powered video, audio, and content solutions.
          </p>
        </motion.div>

        {/* Showcase Images */}
        <motion.div 
          className="absolute bottom-5 left-1/4 flex gap-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {/* <img src={movie1} alt="Movie 1" className="w-40 rounded-lg shadow-xl" />
          <img src={movie2} alt="Movie 2" className="w-40 rounded-lg shadow-xl" /> */}
        </motion.div>
      </section>

      {/* About Section */}
      <section className="py-20 px-6 text-center max-w-4xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-semibold mb-6 text-purple-700"
        >
          Why Media AI Matters
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-lg text-gray-700 leading-relaxed"
        >
          AI is reshaping the media & entertainment industry. From automating video editing to enhancing audio quality, AI-powered solutions improve efficiency, creativity, and audience engagement.
        </motion.p>
      </section>

      {/* Services Section */}
      <section className="py-20 px-6 bg-gradient-to-br from-pink-50 via-white to-purple-50">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-semibold text-center mb-12 text-purple-700"
        >
          Our Media & Entertainment Services
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {[
            { title: "🎬 Video Editing & Post Production", desc: "Smooth transitions, color grading, and motion graphics for all media types.", color: "from-purple-400 to-pink-500" },
            { title: "🎙 Audio Enhancement & Dubbing", desc: "Clear sound, voiceovers, and multi-language dubbing for global audiences.", color: "from-pink-400 to-purple-500" },
            { title: "📺 Content Tagging & Annotation", desc: "Labeling and organizing video & audio content for AI training and media management.", color: "from-indigo-400 to-purple-500" },
            { title: "🌍 Subtitles & Localization", desc: "AI-assisted subtitling and translation for worldwide accessibility.", color: "from-purple-400 to-indigo-500" },
            { title: "📊 Media Analytics & Insights", desc: "Analyze viewership patterns, content performance, and audience engagement.", color: "from-pink-400 to-red-500" },
          ].map((item, idx) => (
            <motion.div
              key={idx}
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className={`bg-gradient-to-br ${item.color} p-6 rounded-2xl shadow-lg text-white hover:shadow-2xl transition`}
            >
              <h3 className="text-xl font-semibold mb-3">{item.title}</h3>
              <p className="leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Workflow Section */}
      <section className="py-20 px-6">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl font-semibold text-center mb-12 text-purple-700"
        >
          How We Work
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 max-w-6xl mx-auto text-center">
          {[
            "Gather media assets",
            "Video & audio editing",
            "Content annotation & tagging",
            "Quality assurance & review",
            "Deliver high-quality media solutions",
          ].map((step, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="p-6 bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl shadow-md hover:shadow-lg"
            >
              <div className="text-4xl mb-3">{`${idx + 1}️⃣`}</div>
              <p className="text-gray-800 leading-relaxed">{step}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 text-center bg-gradient-to-r from-purple-700 to-pink-600 text-white">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-4xl md:text-5xl font-bold mb-6"
        >
          Elevate Your Media Projects With AI
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
          className="text-lg max-w-xl mx-auto mb-6"
        >
          Partner with us to enhance video, audio, and media content using advanced AI solutions and expert workflows.
        </motion.p>
        <motion.button
          whileHover={{ scale: 1.1 }}
          className="bg-white text-purple-700 font-semibold px-6 py-3 rounded-xl shadow-md hover:bg-gray-100 transition"
        >
          Get Started Today
        </motion.button>
      </section>
    </div>
  );
}
